import { useEffect, useRef } from 'react'
import { subscribeMStockPolling } from '@utils/mStockScheduler.js'

export const useMStockPolling = (refetch, period, { enabled = true } = {}) => {
  const taskRef = useRef(refetch)
  taskRef.current = refetch

  useEffect(() => {
    if (!enabled) return

    return subscribeMStockPolling(period, () => taskRef.current?.())
  }, [enabled, period])
}
